import { num } from '../../scene/component-types.js';
import { POST_PROFILE_FIELDS } from '../../scene/forms/post-process.js';
import type { SettingsSection } from '../settings-types.js';

/** `settings.render` (prism_core::RenderSettings): project render defaults and post-processing. */
const graphics: SettingsSection = {
  key: 'render',
  label: 'Graphics',
  icon: 'camera',
  order: 32,
  hint: 'Render defaults, tonemapping, post-processing',
  fields: [
    { key: 'dimension', label: 'Dimension', type: { kind: 'enum', options: ['3d', '2d'] }, read: () => '3d', hint: 'chosen when the project is created' },
    { key: 'style', label: 'Legacy default shader', type: { kind: 'enum', options: ['toon', 'pbr'] }, hint: 'for materials that set neither shader nor toon (unset = standard)' },
    { key: 'shadows', label: 'Shadows', type: { kind: 'bool' }, read: () => true },
    { key: 'msaa', label: 'MSAA (fallback)', type: num(1, { min: 1, max: 8, integer: true }), read: () => 4, hint: 'used when settings.quality.msaa is absent: 1, 2, 4 or 8' },
    { key: 'fov', label: 'Default field of view', type: num(1, { min: 1, max: 179 }), read: () => 70, hint: 'degrees' },
    { key: 'preset', label: 'Art direction', type: { kind: 'string', placeholder: 'realistic, stylized, lowpoly, pixel...' }, hint: 'informs defaults and the assistant’s choices' },
    { key: 'tonemap', label: 'Tonemap', type: { kind: 'enum', options: ['filmic', 'none', 'aces', 'neutral', 'reinhard'] }, hint: 'filmic (3D default) or none (exact colors; 2D default)' },
    { key: 'pixelsPerUnit', label: 'Pixels per unit', type: num(1, { min: 0.01 }), read: () => 100, hint: '2D: sprite pixels per world unit', showIf: (v) => v.dimension === '2d' },
    { key: 'ySort', label: 'Y sort', type: { kind: 'bool' }, read: () => false, hint: '2D top-down: lower sprites draw on top', showIf: (v) => v.dimension === '2d' },
    {
      key: 'postProcess',
      label: 'Post-processing',
      type: { kind: 'object', fields: POST_PROFILE_FIELDS },
      hint: 'project defaults under every postProcess volume (bloom, tonemapping, TAA, ambient occlusion...)',
    },
    {
      key: 'renderTextures',
      label: 'Render textures',
      type: { kind: 'json' },
      hint: 'named render textures cameras render into and materials sample as "rt:<name>"',
    },
  ],
};

export default graphics;
